import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { CdsFormModal } from 'clayco-component-library/lib';
import NameModalForm from './nameModalForm';
import FormSchemas from '../../../utility/schemaLoader';
import Spinner from '../../skills-experience/shared/spinner';
import ChangeType from '../../../shared/profileChangeEnum';

const NameReview = ({data, apiProvider, reloadDetails, reloadChange, setReloadChange}) => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const schema = FormSchemas.nameReview;

    const record = data?.record;
    const pending = data?.pending;

    function handleEdit(){
        console.debug("I've altered the deal...");
        setShowModal(true);
    }

function formatChangeRow(key) {
    const record = data?.record?.[key];
    const pending = data?.pending?.[key] ?? null;
    const admin = data?.admin?.[key] ?? null;

    const adminEqualsPending = admin === pending;
    const adminEqualsRecord = admin === record;

    // If admin is the same as record, ignore both admin and pending
    if (adminEqualsRecord) {
        return <span>{record}</span>;
    }

    // If admin is the same as pending, ignore admin
    if (pending) {
        if (admin && !adminEqualsPending) {
            return (
                <>
                    <span className='cds-text-red cds-strikethrough'>{record}</span>
                    <span className='ms-3 cds-strikethrough' style={{ opacity: 0.4 }}>{pending}</span>
                    <span className='ms-3'>{admin}</span>
                </>
            );
        } else {
            return (
                <>
                    <span className='cds-text-red cds-strikethrough'>{record}</span>
                    <span className='ms-3'>{pending}</span>
                </>
            );
        }
    }

    // No pending, just show admin if it's different from record
    if (admin) {
        return (
            <>
                <span className='cds-text-red cds-strikethrough'>{record}</span>
                <span className='ms-3'>{admin}</span>
            </>
        );
    }

    // Default: show just the record
    return <span>{record}</span>;
}

    async function saveChanges(formData){
        var values = schema.cast(formData);

        setLoading(true);
        values.employeeNumber = data.record.employeeNumber;
        var result = await apiProvider.Post("Profile/Admin/NameEdit", values);

        if (result?.error !== undefined){
            // handle error
            setLoading(false);
        }else{
            // reload data
            // stop loader // close modal   
            setShowModal(false);
            await reloadDetails(ChangeType.NamesChange, data.record.employeeNumber);
            setReloadChange(!reloadChange);
            setLoading(false);
        }
    }

    return(
        <>
        { loading ? 
            <Spinner show={loading}></Spinner>
        :
        <>
        <div className='name-review'>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Legal First Name</span>
            </Col>
            <Col className='col col-12 mb-3'>
                { formatChangeRow('legalFirstName')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className="cds-text-heavy">Legal Last Name</span>
            </Col>
            <Col className='col col-12 mb-3'>
                {formatChangeRow('legalLastName')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Nickname/Preferred First Name</span>
            </Col>
            <Col className='col col-12 mb-3'>
                {formatChangeRow('preferredName')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <span className='cds-text-heavy'>Presentation (Full) Name (Email Signature)</span>
            </Col>
            <Col className='col col-12 mb-2'>
                {formatChangeRow('presentationName')}
            </Col>
        </Row>
        <Row>
            <Col className='col col-12 mb-2'>
                <Button variant='primary' size='sm' aria-label='edit changes'
                    onClick={handleEdit}
                >
                    Edit
                </Button>
            </Col>
        </Row>
        </div>

        <CdsFormModal title={`${data?.record?.preferredName} ${data?.record?.legalLastName}  ${data?.record?.employeeNumber}`}
            schema={schema}
            onError={()=> alert('Something went wrong')}
            onSubmit={saveChanges}
            show={showModal}
            handleCloseClick={()=>{setShowModal(false)}}
        >
            <NameModalForm model={data} />
        </CdsFormModal>
        </>
        }
        </>
    )
};

export default NameReview;